module.exports = __webpack_public_path__ + "img/zsplus.d2520243.png";